export enum DateTypeProps {
  exactDate = 'EXACT_DATE',
  before = 'BEFORE',
  after = 'AFTER',
  customRange = 'CUSTOM_RANGE',
}
